import { useQuery } from '@apollo/client';
import { Box } from '@material-ui/core';
import { MySessionsType } from 'containers/my_sessions/types';
import { GET_MY_SESSIONS } from 'graph_ql/styling_session/queries';
import { useMemo } from 'react';
import styles from '../index.module.scss';
import { getUserProfilePhoto } from 'utils/getUserProfilePhoto';
import utils from 'utils/utils';
import { PATH } from 'routes/constant';
import { useHistory } from 'react-router-dom';
import ArrowRight from 'assets/img/homepage-stylist/arrow-right-icon.png';

export const UpcomingStylingSection = () => {
    const history = useHistory();

    const searchVariables = {
        type: MySessionsType.ALL,
        paging: {
            size: 200,
            page: 0,
        },
    };

    const { data: mySessionsData } = useQuery(GET_MY_SESSIONS, {
        variables: {
            input: searchVariables,
        },
        fetchPolicy: 'network-only',
    });

    const listSessions = useMemo(() => {
        if (mySessionsData?.getMySessions?.data) {
            return mySessionsData?.getMySessions?.data;
        } else {
            return [];
        }
    }, [mySessionsData]);

    const renderSessionCard = ({ session }) => {
        return (
            <Box
                className={styles.sessionCard}
                onClick={() => {
                    history.push(`${PATH.STYLE_REQUEST}/${session?.taffiId}`);
                }}
                key={session?.id}
            >
                <Box display={'flex'} flexDirection={'row'} alignItems={'center'}>
                    <img
                        alt="section-icon"
                        className={styles.sessionCardAvaImg}
                        src={getUserProfilePhoto(session?.customer)}
                    />
                    <Box className={styles.sessionCardName}>
                        {session?.customer?.firstName} {session?.customer?.lastName}
                    </Box>
                </Box>
                <Box className={styles.sessionDescription}>
                    <p className={styles.sessionDescriptionText}>
                        {session?.stylingSessionReason?.isSomethingElse
                            ? session?.subReason?.substring(0, 20).trimEnd()
                            : session?.stylingSessionReason?.value}
                        {session?.subReason?.length >= 20 && '...'}
                    </p>
                    {session?.needSessionWithStylist !== false && (
                        <p className={styles.sessionDateTime}>
                            {utils.getSessionSchedulingStartTime(session?.startTime)}
                        </p>
                    )}
                </Box>
            </Box>
        );
    };

    return (
        <Box className={styles.sectionContainer}>
            <Box
                className={styles.sectionTitle}
                onClick={() => {
                    history.push(PATH.MY_STYLE_REQUESTS);
                }}
            >
                Your Style Requests
            </Box>
            <img
                src={ArrowRight}
                alt="section-icon"
                className={styles.sectionArrowRightIcon}
                onClick={() => {
                    history.push(PATH.MY_STYLE_REQUESTS);
                }}
            />
            {listSessions.length <= 0 && (
                <Box className={styles.sectionEmptyContainer}>
                    <Box className={styles.sectionEmptyLabel}>You have no style requests.</Box>
                    <Box
                        className={styles.sectionEmptyButton}
                        onClick={() => {
                            history.push(`${PATH.MY_STYLE_REQUESTS}?type=${MySessionsType.COMPLETED}`);
                        }}
                    >
                        View past requests
                    </Box>
                </Box>
            )}
            {listSessions.slice(0, 5).map((session) => renderSessionCard({ session }))}
        </Box>
    );
};
